import { render, staticRenderFns } from "./rechargeModal.vue?vue&type=template&id=2bca1285&scoped=true"
import script from "./rechargeModal.vue?vue&type=script&lang=js"
export * from "./rechargeModal.vue?vue&type=script&lang=js"
import style0 from "./rechargeModal.vue?vue&type=style&index=0&id=2bca1285&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca1285",
  null
  
)

export default component.exports